import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChatCircleText, X } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/** "Your question was answered" pin — stays on Home until the author opens the answer or dismisses it.
 *  Marking the bell notification read does NOT clear it (server rule). */
export const AnswerPin = () => {
    const { user } = useAuth();
    const [pin, setPin] = useState(null);
    useEffect(() => {
        if (!user) return;
        api.get("/me/answer-pin").then(({ data }) => setPin(data.pin)).catch(() => setPin(null));
    }, [user]);
    if (!pin) return null;
    const dismiss = async () => {
        setPin(null);
        try { await api.post("/me/answer-pin/dismiss", { question_id: pin.question_id }); } catch { /* best effort */ }
    };
    return (
        <div className="relative border border-emerald-500/40 bg-emerald-500/[0.06] rounded-md p-3 sm:p-4 mb-4" data-testid="answer-pin">
            <button onClick={dismiss} aria-label="dismiss answer pin" data-testid="answer-pin-dismiss"
                    className="absolute top-1.5 right-1.5 min-w-[44px] min-h-[44px] flex items-center justify-center text-slate-500 hover:text-slate-200"><X size={16} /></button>
            <div className="flex items-start gap-3 pr-10">
                <ChatCircleText size={22} weight="duotone" className="text-emerald-300 shrink-0 mt-0.5" />
                <div className="min-w-0">
                    <div className="text-[10px] uppercase tracking-widest font-mono text-emerald-300">// your question was answered</div>
                    <div className="text-sm sm:text-base font-bold text-slate-100 leading-snug mt-0.5 line-clamp-2" data-testid="answer-pin-title">{pin.title}</div>
                    {pin.preview && <p className="text-xs text-slate-400 mt-1 line-clamp-2">{pin.answered_by ? `@${pin.answered_by}: ` : ""}{pin.preview}</p>}
                    <Link to={pin.link} data-testid="answer-pin-open"
                          className="inline-flex items-center mt-2 min-h-[44px] sm:min-h-[36px] px-3 rounded-sm bg-emerald-400 hover:bg-emerald-300 text-slate-950 font-bold text-[10px] uppercase tracking-widest">read the answer →</Link>
                </div>
            </div>
        </div>
    );
};
